import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { loadConfig } from "./config";

// Load runtime config (/config.json) before mounting the app. Every API
// request resolves its base URL synchronously via src/config.ts, so the
// config must be in place before the first request fires.
loadConfig().then(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
